<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>-->
<!--      <a-col :span="24">-->
<!--        <a-form-item label="查询条件" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--          <a-input v-model="key" placeholder="请输入医生姓名、患者名称或房间号"></a-input>-->
<!--        </a-form-item>-->
<!--      </a-col>-->
<!--      <a-button type="primary"icon="plus" @click="selectListByKey()">查询</a-button>-->
      <a-button type="primary" icon="download" @click="handleExportXls('房间记录表')">导出</a-button>
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">导入</a-button>-->
<!--      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <room-scord-modal ref="modalForm" @ok="modalFormOk"></room-scord-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import RoomScordModal from './modules/RoomScordModal'
  import { deleteAction, getAction } from '../../api/manage'
  export default {
    name: 'RoomScordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      RoomScordModal
    },
    data () {
      return {
        description: '房间记录表管理页面',
        query: {//用于查询
          key: this.key,//必须要定义下拉菜单，否则下拉菜单会不能进行选择
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'房间号',
            align:"center",
            dataIndex: 'roomNumber'
          },
          {
            title:'医生姓名',
            align:"center",
            dataIndex: 'doctorName'
          },
          {
            title:'患者名称',
            align:"center",
            dataIndex: 'patientName'
          },
          {
            title:'日期',
            align:"center",
            dataIndex: 'date',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'问诊开始时间',
            align:"center",
            dataIndex: 'startTime'
          },
          {
            title:'问诊结束时间',
            align:"center",
            dataIndex: 'endTime'
          },
          {
            title:'是否发送',
            align:"center",
            dataIndex: 'status'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/RoomScord/roomScord/list?key="+this.key,
          delete: "/RoomScord/roomScord/delete",
          deleteBatch: "/RoomScord/roomScord/deleteBatch",
          exportXlsUrl: "/RoomScord/roomScord/exportXls",
          importExcelUrl: "RoomScord/roomScord/importExcel",
          selectListByKey: "/RoomScord/roomScord/list"

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      //安条件查询
      selectListByKey() {
          let params = {key:this.key};
          getAction(this.url.selectListByKey,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>